import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * Shared button component with consistent styling
 */
@Component({
  selector: 'lib-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  type = input<'button' | 'submit' | 'reset'>('button');
  variant = input<'raised-button' | 'flat-button' | 'stroked-button'>('raised-button');
  color = input<'primary' | 'accent' | 'warn'>('primary');
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
}

